module.exports = __webpack_public_path__ + "static/img/11.980e2a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/eng/11.png
// module id = rJih
// module chunks = 0